module.exports = __webpack_public_path__ + "static/media/pure-fitout-associated.48cf22f5.png";